import { alpha, AppBar, Box, Button, Container, Divider, Drawer, IconButton, InputBase, Link, List, ListItem, ListItemIcon, ListItemText, Menu, MenuItem, styled, Toolbar } from "@mui/material"
import React, { ReactNode } from "react"
import DehazeIcon from '@mui/icons-material/Dehaze';
import SearchIcon from '@mui/icons-material/Search'
import HomeIcon from '@mui/icons-material/Home'
import WorkIcon from '@mui/icons-material/Work'
import AnnouncementIcon from '@mui/icons-material/Announcement'
import AccountBoxIcon from '@mui/icons-material/AccountBox'
import MailIcon from '@mui/icons-material/Mail'
import DescriptionIcon from '@mui/icons-material/Description'

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}));

export interface AppBarProps {
}

const MyAppBar = (props: AppBarProps) => {
  const [drawerState, setDrawerState] = React.useState(false)
  const toggleDrawer = (event: React.KeyboardEvent | React.MouseEvent) => {
    if (event.type === "keydown") {
      const e: React.KeyboardEvent = event as any as React.KeyboardEvent
      if (e.key === "Tab" || e.key === "Shift") {
        return
      }
    }
    setDrawerState(!drawerState)
  }

  const menuItemStyles = {
    color: "black"
  }
  return (
    <AppBar component="nav" color="inherit">
      <Container maxWidth="xl">
        <Toolbar disableGutters style={{ padding: "8px"}}>
          <Link href="/">
            <img src="/assets/images/logo.png" style={{ width: "120px"}} />
          </Link>
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex"}}} color="inherit">
            <Button variant="text" href="/" sx={{ marginLeft: "4px", my: 2, color: 'white', display: 'block'}} style={menuItemStyles}>
              Home
            </Button>
            <Button variant="text" href="/blog/" sx={{ my: 2, color: 'white', display: 'block'}} style={menuItemStyles}>
              ブログ
            </Button>
            <Button variant="text" href="/services/" sx={{ my: 2, color: 'white', display: 'block'}} style={menuItemStyles}>
              サービス一覧
            </Button>
            <Button variant="text" href="/news/" sx={{ my: 2, color: 'white', display: 'block'}} style={menuItemStyles}>
              新着一覧
            </Button>
            <Button variant="text" href="/profile/" sx={{ my: 2, color: 'white', display: 'block'}} style={menuItemStyles}>
              プロフィール
            </Button>
            <Button variant="text" href="/contact/form/" sx={{ my: 2, color: 'white', display: 'block'}} style={menuItemStyles}>
              お問合せ
            </Button>
          </Box>
          {/* <Search sx={{ display: { xs: 'none', md: 'flex'}}}>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase placeholder="Search..." inputProps={{ 'aria-label': 'search'}} />
          </Search> */}
          <Box sx={{ flexGrow: 1, display: {xs: "flex", md: "none"}}}></Box>
          <Box sx={{ display: {xs: "flex", md: "none"}}}>
            <IconButton onClick={toggleDrawer} sx={{ p: 0}}>
              <DehazeIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </Container>
      <Drawer anchor="right" open={drawerState} onClose={toggleDrawer}>
        <Box sx={{ width: 320}} role="presentation" onClick={toggleDrawer} onKeyDown={toggleDrawer}>
          <List>
            <ListItem button component="a" key="Home" href="/">
              <ListItemIcon><HomeIcon /></ListItemIcon>
              <ListItemText primary="Home" />
            </ListItem>
            <ListItem button component="a" key="Services" href="/services/">
              <ListItemIcon><WorkIcon /></ListItemIcon>
              <ListItemText primary="サービス一覧" />
            </ListItem>
            <ListItem button component="a" key="News" href="/news/">
              <ListItemIcon><AnnouncementIcon /></ListItemIcon>
              <ListItemText primary="新着情報" />
            </ListItem>
            <ListItem button component="a" key="Profile" href="/profile/">
              <ListItemIcon><AccountBoxIcon /></ListItemIcon>
              <ListItemText primary="SEM Technologyについて" />
            </ListItem>
            <ListItem button component="a" key="Contact" href="/contact/form/">
              <ListItemIcon><MailIcon /></ListItemIcon>
              <ListItemText primary="お問合せ" />
            </ListItem>
          </List>
          <Divider />
          <List>
            <ListItem button component="a" key="Blog" href="/blog/">
              <ListItemIcon><DescriptionIcon /></ListItemIcon>
              <ListItemText primary="ブログ" />
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </AppBar>
  )
}

export default MyAppBar
